import React from "react";
import * as Mui from "@mui/material";
import { sharedTableBodyCellSx } from "components/DesignSystem/sharedUiPatterns";
import { TruncatedTableValue } from "components/DesignSystem/tableColumnSizing";
import { designColors, designRadii, designShell, designType, designWeights } from "services/constants/designTokens";
import { tooltipStyleProps } from "services/constants/Styles";

// Compact tables inside a side panel (e.g. Change Payroll Cycle). They use a
// fixed layout with set column widths so they fit the standard panel width
// instead of scrolling sideways. Headers may wrap; long body text ends in an
// ellipsis and shows in full on hover (CellText).

export const compactHeadSx = { ...designShell.tableHeadCellBase, py: 0.75, px: 1, lineHeight: 1.3 };
export const compactCellSx = { ...sharedTableBodyCellSx, py: 0.75, px: 1, fontSize: 13 };
export const fitTableSx = { tableLayout: "fixed", width: "100%" };
// The checkbox column must not clip or ellipsis-truncate the checkbox.
export const checkCellSx = { px: 0.5, textAlign: "center", overflow: "visible", textOverflow: "clip" };
export const tableBoxSx = {
  border: `1px solid ${designColors.slate200}`,
  borderRadius: designRadii.card,
  overflowX: "hidden",
};

// Cell text that may be cut off with an ellipsis; hovering shows it in full.
export const CellText = ({ text }) => (
  <Mui.Tooltip title={text} arrow placement="top" slotProps={tooltipStyleProps}>
    <Mui.Box component="span">{text}</Mui.Box>
  </Mui.Tooltip>
);

// List-screen cells: plain text/number values are cut off with an ellipsis
// and show in full in the styled tooltip, only when actually cut off.
// Chips and other elements are returned unchanged.
export const truncatableCell = (content) =>
  typeof content === "string" || typeof content === "number" ? (
    <TruncatedTableValue value={content} />
  ) : (
    content
  );

// Two-line Employee cell (name over code); each line gets its own tooltip.
export const EmployeeCell = ({ name, code }) => (
  <Mui.Box sx={{ minWidth: 0 }}>
    <Mui.Typography component="div" sx={{ ...designType.tableBodyCell, fontWeight: designWeights.medium }}>
      <TruncatedTableValue value={name || "–"} />
    </Mui.Typography>
    <Mui.Typography component="div" sx={designType.captionText}>
      <TruncatedTableValue value={code || "–"} />
    </Mui.Typography>
  </Mui.Box>
);

// widths: one entry per column (px number, or null for "share the rest").
export const ColWidths = ({ widths }) => (
  <colgroup>
    {widths.map((width, index) => (
      <col key={index} style={width ? { width } : undefined} />
    ))}
  </colgroup>
);
